import { dataLayerLogger } from './logger';
import { getInitialState } from '../services/initialState';

function pushToDataLayer(data: { [key: string]: any }): boolean {
    return window.dataLayer?.push(data) ?? false;
}

// SLT-1917
enum DataLayerEvents {
    Init = 'INIT',
}

enum DataLayerPageType {
    CountryPage = 'country-page',
    HotelPage = 'hotel-page',
    ResortPage = 'resort-page',
}

interface DataLayerVarsOnInitForCountryPage {
    event: DataLayerEvents;
    pageType: DataLayerPageType;
    lang: 'ru';
    countryId: number; // 90
    countryName: string; // ОАЭ
    countryOriginalName: string; // UAE
}

interface DataLayerVarsOnInitForResortPage {
    event: DataLayerEvents;
    pageType: DataLayerPageType;
    lang: 'ru';
    resortId: number; // 1264
    resortName: string; // 'Санкт-Петербург'
    resortOriginalName: string; // 'Saint-Petersburg'
    countryId: number; // 150
    countryName: string; // Россия
    countryOriginalName: string; // Russia
}

interface DataLayerVarsOnInitForHotelPage {
    event: DataLayerEvents;
    pageType: DataLayerPageType;
    lang: 'ru';
    hotelId: number; // 30107
    hotelName?: string; // Орсмарис Бутик Отель
    hotelOriginalName: string; // Orsmaris Boutique Hotel
    resortId: number; // 765
    resortName: string; // Мармарис;
    countryId: number; // 119
    countryName: string; // Турция
}

// страница страны
export function pushToDataLayerOnInitForCountryPage(): void {
    const countryInfo = getInitialState().pageModel.countryInfo;

    const dataLayerVars: DataLayerVarsOnInitForCountryPage = {
        event: DataLayerEvents.Init,
        pageType: DataLayerPageType.CountryPage,
        lang: 'ru',
        countryId: countryInfo.id,
        countryName: countryInfo.name,
        countryOriginalName: countryInfo.originalName,
    };

    dataLayerLogger.debug('sending after initialization: ', dataLayerVars);
    pushToDataLayer(dataLayerVars);
}

// страница отеля
export function pushToDataLayerOnInitForHotelPage(): void {
    const hotelDetails = getInitialState().pageModel.hotelDetails;

    const dataLayerVars: DataLayerVarsOnInitForHotelPage = {
        event: DataLayerEvents.Init,
        pageType: DataLayerPageType.HotelPage,
        lang: 'ru',
        hotelId: hotelDetails.id,
        hotelOriginalName: hotelDetails.originalName,
        resortId: hotelDetails.resortId,
        resortName: hotelDetails.resortName,
        countryId: hotelDetails.countryId,
        countryName: hotelDetails.countryName,
    };

    if (hotelDetails.name) {
        dataLayerVars.hotelName = hotelDetails.name;
    }

    dataLayerLogger.debug('sending after initialization: ', dataLayerVars);
    pushToDataLayer(dataLayerVars);
}

// страница курорта
export function pushToDataLayerOnInitForResortPage(): void {
    const currentResort = getInitialState().pageModel.currentResort;
    const countryInfo = getInitialState().pageModel.country;

    const dataLayerVars: DataLayerVarsOnInitForResortPage = {
        event: DataLayerEvents.Init,
        pageType: DataLayerPageType.ResortPage,
        lang: 'ru',
        resortId: currentResort.id,
        resortName: currentResort.name,
        resortOriginalName: currentResort.originalName,
        countryId: countryInfo.id,
        countryName: countryInfo.name,
        countryOriginalName: countryInfo.originalName,
    };

    dataLayerLogger.debug('sending after initialization: ', dataLayerVars);
    pushToDataLayer(dataLayerVars);
}
